import { VastaRX } from "@vasta/rx";
import { ObserverMensagemStatusConexao } from "../interfaces/bluetooth-interface";

export const setObserverMensagemStatusConexao = (options: ObserverMensagemStatusConexao) => {
  VastaRX.setState('observer_mensagem_status_conexao', options)
}
